import React from 'react';
import { Section } from '../ui/Section';
import { UserCheck } from 'lucide-react';
export function WhoItsFor() {
  const criteria = ['Sienten punzadas o ardor nocturno en las manos', 'No pueden encontrar una posición cómoda para dormir', 'Se despiertan por dolor y les cuesta volver a dormir', 'Quieren una rutina suave y sostenible (no agresiva)'];
  return <Section background="navy" data-id="element-190">
      <div className="bg-[#0f1419] rounded-2xl p-8 md:p-12 border border-[#2a3245] relative overflow-hidden" data-id="element-191">
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#d4af37] to-transparent opacity-50" data-id="element-192" />

        <div className="flex flex-col md:flex-row gap-10 items-center" data-id="element-193">
          <div className="flex-1" data-id="element-194">
            <h2 className="text-3xl font-bold text-[#f5f0e8] mb-6 font-serif" data-id="element-195">
              Para quién es esto
            </h2>
            <p className="text-lg text-[#d4af37] mb-6 font-medium" data-id="element-196">
              Diseñado específicamente para mujeres 40+ que:
            </p>
            <ul className="space-y-4" data-id="element-197">
              {criteria.map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-198">
                  <div className="mt-1 min-w-[20px] h-5 rounded-full border border-[#d4af37] flex items-center justify-center" data-id="element-199">
                    <div className="w-2.5 h-2.5 bg-[#d4af37] rounded-full" data-id="element-200" />
                  </div>
                  <span className="text-gray-300" data-id="element-201">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="flex-shrink-0 bg-[#1a1f2e] p-8 rounded-full border border-[#2a3245] shadow-xl" data-id="element-202">
            <UserCheck className="w-16 h-16 text-[#d4af37]" data-id="element-203" />
          </div>
        </div>
      </div>
    </Section>;
}